import { EditPermissions } from '../../../../../../../shared/models';
import { getEditTypes } from '../../../delegatorUtils';
import { newStepValue } from '../../../../../services/flowBuilder/utils/constants';
import { Form, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { required } from '../../../../../../../shared/utils';

export interface MediaFormData {
  varName: string;
  text: string;
  mediaDirection: string;
  filename: string;
  endSession: boolean;
  varType: string;
  next: string;
}

export class Media {
  private menu: any = {};

  constructor() {
    this.menu = {
      'menuType': 'media',
    };
  }

  static toForm(stepData: { [index: string]: any }, editPermissions: EditPermissions): UntypedFormGroup {
    const {editMenuTextOnly, editFlows} = getEditTypes(editPermissions);
    const formData = this.getFromData(stepData);

    return this.buildForm(formData, editFlows);
  }

  private static getFromData(stepData: { [index: string]: any }): MediaFormData {
    const menu = stepData?.menu ? stepData?.menu : {};
    const input = menu?.input ? menu?.input : {};
    const menuParams = menu?.menuParams ? menu?.menuParams : {};

    return {
      varName: this.getOrDefault(input?.varName),
      text: this.getOrDefault(menu?.text),
      mediaDirection: menu['media-direction'] ? menu['media-direction'] : 'inbound',
      filename: this.getOrDefault(menuParams?.filename),
      endSession: menuParams?.endSession ? menuParams.endSession : false,
      varType: menuParams?.varType ? menuParams.varType : 'API',
      next: stepData.next ? stepData.next : newStepValue
    };
  }

  private static getOrDefault(value: string, defaultValue: any = ''): any {
    if (value === undefined || !value) {
      return defaultValue;
    }

    return value;
  }

  private static buildForm(formData: MediaFormData, editFlows: boolean): UntypedFormGroup {
    return new UntypedFormGroup({
      varName: new UntypedFormControl({
        value: formData.varName,
        disabled: !editFlows
      }, required('Variable')),
      text: new UntypedFormControl({
        value: formData.text,
        disabled: !editFlows
      }),
      mediaDirection: new UntypedFormControl({
        value: formData.mediaDirection,
        disabled: !editFlows
      }),
      filename: new UntypedFormControl({
        value: formData.filename,
        disabled: !editFlows
      }),
      endSession: new UntypedFormControl({
        value: formData.endSession ? formData.endSession : false,
        disabled: !editFlows
      }),
      varType: new UntypedFormControl({
        value: formData.varType,
        disabled: !editFlows
      }),
      next: new UntypedFormControl({
        value: formData.next,
        disabled: !editFlows
      })
    });
  }

  public setMenu(rawData): void {
    const input = {
      varName: rawData.varName
    };

    const menu = {
      ...this.menu,
      input,
      'media-direction': rawData.mediaDirection,
      text: rawData.text
    };

    const menuParams = {};

    if (rawData.mediaDirection === 'outbound') {
        menuParams['filename'] = rawData.filename;
        menuParams['endSession'] = rawData.endSession;
        menuParams['varType'] = rawData.varType;
    }

    this.menu = {
      ...menu,
      menuParams
    };
  }

  get nodeData(): {} {
    return {
      menu: this.menu,
      'type': 'menu',
      metadata: {
        nodeVersion: '1.0.0'
      }
    };
  }
}
